import React, { useCallback, useEffect, useMemo, useState } from "react";
import Swal from "sweetalert2";
import axios from "../../services/axios";
import useWarehouse from "../../services/queries/useWarehouse";
import useUser from "../../services/queries/useUser";
// import useItem from "../../services/queries/useItem";
import toRibuan from "../../utils/toRibuan";
import defaultAxios, { AxiosError } from "axios";
import { useAuth } from "../../context/authContext";
import { useTransaksi } from "../../context/transaksiContext";
import { getLocalWarehouseId } from "../../utils/handleChangeWarehouseId";
import { BlobProvider } from "@react-pdf/renderer";
import { LoadingButton } from "@mui/lab";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
    Box,
    Dialog,
    DialogTitle,
    Grid,
    Stack,
    Typography,
    IconButton,
    DialogContent,
    FormControlLabel,
    Checkbox,
    Button,
    Autocomplete,
    TextField,
    InputAdornment,
    ToggleButtonGroup,
    ToggleButton,
    Tooltip,
} from "@mui/material";
import {
    IFaktur,
    IOptions,
    // ParamsGetItem,
    ParamsGetWarehouse,
    TipeStruk,
    DaftarKategoriListInvoice,
    ContentGetPelangganResponse,
    ParamsGetPelanggan,
    PaymentMethodData,
    MetodePembayaranData,
} from "../../constants/types";
import PrintStrukPdf from "../PrintStruk/PrintStrukPdf";
import useMetodePembayaran from "../../services/queries/useMetodePembayaran";
import ModalAlertPro from "../ModalAlertPro/ModalAlertPro";
import { Print } from "@mui/icons-material";
import { IconContext } from "react-icons";
import { GiMoneyStack, GiWallet } from "react-icons/gi";
import moment from "moment";
import PrintStrukA4 from "../PrintStrukA4/PrintStrukA4";
import truncate from "../../utils/truncate";
// import printJS from "print-js-updated";

import useListInvoice from "../../services/queries/useListInvoice";
import { Controller, useForm } from "react-hook-form";
import usePelanggan from "../../services/queries/usePelanggan";
import usePaymentMethod from "../../services/queries/usePaymentMethod";

interface IModalKonfirmasiBayarProps {
    refetch: () => void;
    persentaseDiskon?: number | null;
    diskon?: number;
    persentasePajak?: number | null;
    pajak?: number;
    totalTagihan: number;
    uangDibayar: number;
    kembalian: number;
    kasir: string;
    sales: IOptions | null;
    keteranganBeli: string;
    resetKeteranganBeli: () => void;
}

interface CartItem {
    namaKategori: string;
    namaBarang: string;
    harga: number;
    qty: number;
}

enum ModePembayaran {
    TUNAI = "tunai",
    TRANSFER = "transfer",
}

type ToggleKirimStruk = "email" | "whatsapp";

interface IValues {
    isPelangganBaru: boolean;
    nama: string;
    alamat: string;
    noTelepon: string;
    pelanggan?: ContentGetPelangganResponse;
    selectedMetode?: MetodePembayaranData | null;
    isPG: boolean;
    metodeBayar?: PaymentMethodData | null;
}

export const ModalKonfirmasiBayar = (props: IModalKonfirmasiBayarProps) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));
    let now = moment().format("DD MMM YYYY HH:mm");

    const { warehouseIdUser } = useAuth();
    const { data: user } = useUser();

    const initialParamsWarehouse = {
        size: 500,
        page: 1,
        search: "",
    };

    const [paramsWarehouse, setParamsWarehouse] =
        React.useState<ParamsGetWarehouse>(initialParamsWarehouse);
    const { data: warehouse } = useWarehouse(paramsWarehouse);

    // const initialParams = {
    //     warehouseId: warehouseIdUser && warehouseIdUser[0],
    //     size: 500,
    //     page: 1,
    //     search: "",
    //     kategori: "",
    // };

    const [printStruk, setPrintStruk] = useState(false);
    const [kirimEmail, setKirimEmail] = useState(false);
    const [email, setEmail] = useState("");
    // const [paramsItem, setParamsItem] = useState<ParamsGetItem>(initialParams);
    const [totalHargaSeluruhItem, setTotalHargaSeluruhItem] = useState(0);
    // const { refetch: refetchItem } = useItem(paramsItem);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [toggleModePembayaran, setToggleModePembayaran] = useState(
        ModePembayaran.TUNAI,
    );
    const [isOpenModalAlertPro, setIsOpenModalAlertPro] = useState(false);
    const [toggleKirimStruk, setToggleKirimStruk] =
        useState<ToggleKirimStruk>("whatsapp");
    const [tipeStruk, setTipeStruk] = useState<string | null>(
        localStorage.getItem("tipeStrukBayar") ?? TipeStruk.Mobile,
    );
    const [tipeStrukTagihan, setTipeStrukTagihan] = useState<string | null>(
        localStorage.getItem("tipeStrukInvoice") ?? TipeStruk.Mobile,
    );

    const handleTipeStruk = (
        _event: React.MouseEvent<HTMLElement>,
        newTipeStruk: TipeStruk | null,
    ) => {
        if (newTipeStruk !== null) {
            setTipeStruk(newTipeStruk);
            localStorage.setItem("tipeStrukBayar", newTipeStruk);
        }
    };

    const handleTipeStrukTagihan = (
        _event: React.MouseEvent<HTMLElement>,
        newTipeStruk: TipeStruk | null,
    ) => {
        if (newTipeStruk !== null) {
            setTipeStrukTagihan(newTipeStruk);
            localStorage.setItem("tipeStrukInvoice", newTipeStruk);
        }
    };

    const pilihWhatsapp = () => {
        setToggleKirimStruk("whatsapp");
        setEmail("");
    };

    const pilihEmail = () => {
        setToggleKirimStruk("email");
        setEmail("");
    };

    const warehouseId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalWarehouseId(user?.userId);
        }
        return null;
    }, [user?.userId]);

    const warehouseData = React.useMemo(() => {
        if (warehouseId) {
            return warehouse?.content.find((li) => li.id === warehouseId);
        }
        return warehouse?.content[0];
    }, [warehouse?.content, warehouseId]);

    const { data: metodePembayaran, isLoading: isLoadingMetodePembayaran } =
        useMetodePembayaran(warehouseId);

    const [paramsPaymentMethod, setParamsPaymentMethod] = useState<number>();

    const { data: paymentMethod, isLoading: isLoadingPaymentMethod } =
        usePaymentMethod(paramsPaymentMethod);

    // const { data: findCustomStruk } = useFindCustomStruk(Number(warehouseId));

    const initialParamsListInvoice = {
        warehouseId: warehouseIdUser && warehouseIdUser[0],
        search: "",
        size: 100,
        page: 1,
        tanggalAwal: now,
        tanggalAkhir: now,
        kasir: "",
        sales: "",
        metodeId: "",
        voidInvoice: "",
    };

    const { data: listInvoice } = useListInvoice(initialParamsListInvoice);

    const transaksiKe =
        (Number(listInvoice?.content?.[0]?.transaksiKe) || 0) + 1;

    const initialParamsPelanggan = {
        warehouseId: warehouseIdUser && warehouseIdUser[0],
        size: 500,
        page: 1,
        search: "",
    };
    const [paramsPelanggan, setParamsPelanggan] =
        React.useState<ParamsGetPelanggan>(initialParamsPelanggan);

    const { data: pelanggan, isLoading: isLoadingPelanggan } =
        usePelanggan(paramsPelanggan);

    const pilihTunai = () => {
        setToggleModePembayaran(ModePembayaran.TUNAI);
    };

    const pilihTransfer = () => {
        setToggleModePembayaran(ModePembayaran.TRANSFER);
    };

    const {
        cart,
        totalHarga,
        isOpenModalKonfirmasiBayar,
        closeModalBayar,
        closeModalKonfirmasiBayar,
        // resetCart,
        handleReset,
        // isPrintStruk,
        // resetPrint,
        setFetchingItems,
        handlingDonePembayaran,
        // diskon,
        // grandTotal,
        // bayar,
        // kembalian,
        checked,
        setChecked,
        // keteranganBeli,
        handleIsKeterangan,
        // resetKeteranganBeli,
    } = useTransaksi();

    const current = new Date();
    current.getSeconds();

    const handleHitungTotalHargaSeluruhItem = useCallback(() => {
        let total = 0;
        if (cart) {
            cart.forEach((list) => {
                total += list.harga * list.qty;
            });
            setTotalHargaSeluruhItem(total);
            return;
        }
    }, [cart]);

    useEffect(() => {
        handleHitungTotalHargaSeluruhItem();
    }, [cart, handleHitungTotalHargaSeluruhItem]);

    const handlePrintStruk = (checked: boolean) => {
        if (checked) {
            setPrintStruk(true);
        } else {
            setPrintStruk(false);
        }
    };

    const handleKirimEmail = (checked: boolean) => {
        if (checked) {
            setEmail("");
            setKirimEmail(true);
        } else {
            setKirimEmail(false);
        }
    };

    useEffect(() => {
        if (localStorage.getItem("printStruk") === "true") {
            setPrintStruk(true);
        } else {
            setPrintStruk(false);
        }
    }, []);

    const filterNewKodeFaktur = (idBundling: number) => {
        let kodeFakturBundling: IFaktur[] = [];
        cart.forEach((li) =>
            li.detailBundling
                .filter((fd) => fd.bundlingId === idBundling)
                .forEach((db) => {
                    if (db.newFaktur) {
                        db.newFaktur.forEach((nf) => {
                            kodeFakturBundling.push(nf);
                        });
                    }
                }),
        );
        return kodeFakturBundling.map((li) => ({
            idFaktur: li.fakturId,
            kodeFaktur: li.kodeFaktur,
            jumlahItem: li.jumlahItem,
        }));
    };

    const [groupByKategori, setGroupByKategori] = useState(false);

    const handleCheckboxKategori = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setGroupByKategori(event.target.checked);
    };

    const initialValues: IValues = useMemo(
        () => ({
            isPelangganBaru: false,
            nama: "",
            alamat: "",
            noTelepon: "",
            isPG: false,
        }),
        [],
    );

    const {
        handleSubmit,
        control,
        reset,
        watch,
        setValue,
        formState: { errors },
    } = useForm<IValues>({
        defaultValues: initialValues,
        mode: "all",
    });
    const watchIsPelangganBaru = watch("isPelangganBaru");
    const watchIsPG = watch("isPG");
    const watchSelectedMetode = watch("selectedMetode");
    const watchMetodeBayar = watch("metodeBayar");

    useEffect(() => console.log("errors", errors), [errors]);

    const onSubmit = handleSubmit(async (values: IValues) => {
        setIsButtonLoading(true);
        const formattedNoTelp = "62" + values.noTelepon;
        const body = {
            warehouseId: warehouseIdUser && warehouseIdUser[0],
            jenisItem: cart.map((li) => ({
                itemId: li.id,
                namaItem: li.namaBarang,
                namaKategori: li.namaKategori,
                skuItem: li.sku,
                jumlahItem: li.qty,
                hargaSatuan: li.harga,
                hargaTotal: li.harga * li.qty,
                kodeFaktur: checked
                    ? li.detailBundling.length > 0
                        ? filterNewKodeFaktur(li.id)
                        : li.faktur.map((fa) => ({
                              idFaktur: fa.fakturId,
                              kodeFaktur: fa.kodeFaktur,
                              jumlahItem: fa.jumlahItem,
                          }))
                    : null,
            })),
            userInput: `${user?.userId}`,
            sales: !!props.sales ? props.sales.id : null,
            totalHarga: totalHargaSeluruhItem,
            diskon: props.diskon,
            pajak: props.pajak,
            // pajakPersen: warehouseData?.pajak,
            totalPembayaran: props.totalTagihan,
            uangYangDibayar: values.isPG
                ? props.totalTagihan
                : props.uangDibayar,
            kembalian: values.isPG ? 0 : props.kembalian,
            metodeId:
                toggleModePembayaran === ModePembayaran.TUNAI
                    ? 0
                    : values.selectedMetode?.id ?? 0,
            email: toggleKirimStruk === "email" ? email : null,
            keterangan: !!props.keteranganBeli ? props.keteranganBeli : null,
            charge: values.selectedMetode
                ? values.selectedMetode.charge.charge
                : null,
            tipeCharge: values.selectedMetode
                ? values.selectedMetode.charge.mode
                : null,
            mPelangganId: values.isPelangganBaru ? null : values.pelanggan?.id,
            mPelangganBaru: values.isPelangganBaru
                ? {
                      nama: values.nama,
                      noTelp: formattedNoTelp,
                      alamat: values.alamat,
                  }
                : null,
            isPG: values.isPG ? 1 : undefined,
            duitkuPaymentMethod: values.metodeBayar?.paymentMethod ?? null,
            duitkuPaymentName: values.metodeBayar?.paymentName ?? null,
            duitkuPaymentFee: values.metodeBayar?.totalFee ?? null,
        };

        const params = {
            grupProduk: groupByKategori ? 1 : 0,
        };

        try {
            const { data } = await axios.post("/api/pembayaran", body, {
                params,
            });
            if (data.code === 200) {
                // setTransaksiKe(String(data.data.transaksiKe));
                console.log("Data transaksiKe:", String(data.data.transaksiKe));
                if (kirimEmail && toggleKirimStruk === "whatsapp") {
                    window.open(
                        `https://wa.me/62${email}?text=Struk%20pembayaran%20Puffhaven%20${data.data.nomorInvoice}%20${window.location.origin}/struk/${data.data.encrypt}`,
                        "_blank",
                    );
                }
                closeModalKonfirmasiBayar();
                closeModalBayar();
                Swal.fire({
                    title: "Transaksi berhasil!",
                    text: values.isPG
                        ? "Silahkan tekan tombol berikut untuk menyelesaikan pembayaran"
                        : "Pembayaran Anda telah berhasil",
                    icon: "success",
                    confirmButtonColor: "#45A779",
                    confirmButtonText: values.isPG
                        ? "Lanjutkan Pembayaran"
                        : "Oke",
                    customClass: {
                        container: "my-swal",
                    },
                }).then((result) => {
                    if (result.isConfirmed && values.isPG) {
                        window.open(data.data.pgDuitku.payment_url, "_blank");
                    }
                });
                if (printStruk) {
                    localStorage.setItem("printStruk", "true");
                } else {
                    localStorage.removeItem("printStruk");
                }
                setFetchingItems();
                handleReset();
                setChecked(false);
                setIsButtonLoading(false);
                handleIsKeterangan(false);
                props.resetKeteranganBeli();
                handlingDonePembayaran();
            }
        } catch (error) {
            setIsButtonLoading(false);
            handleErrorResponse(error);
        }
    });

    const handleErrorResponse = useCallback(
        (error) => {
            if (defaultAxios.isAxiosError(error)) {
                const serverError = error as AxiosError<any>;
                if (serverError && serverError.response) {
                    closeModalKonfirmasiBayar();
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `${serverError.response.data.data}`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    closeModalBayar();
                } else {
                    closeModalKonfirmasiBayar();
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `Telah Terjadi Kesalahan`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    closeModalBayar();
                }
            }
        },
        [closeModalBayar, closeModalKonfirmasiBayar],
    );

    // useEffect(() => {
    //     if (warehouseIdUser) {
    //         setParamsItem((prev) => ({
    //             ...prev,
    //             warehouseId: warehouseIdUser && warehouseIdUser[0],
    //         }));
    //     }
    // }, [warehouseIdUser]);

    useEffect(() => {
        if (props.totalTagihan) {
            setParamsPaymentMethod(Number(props.totalTagihan));
        }
    }, [props.totalTagihan]);

    React.useEffect(() => {
        if (user && user?.warehouseId?.length > 0) {
            setParamsWarehouse((prev) => ({
                ...prev,
                userId: user.warehouseId[0],
            }));
        }
    }, [user]);

    const groupItemsByCategory = (items: CartItem[]) => {
        return items.reduce((acc, item) => {
            if (!acc[item.namaKategori]) {
                acc[item.namaKategori] = [];
            }
            acc[item.namaKategori].push(item);
            return acc;
        }, {} as { [key: string]: CartItem[] });
    };

    const groupedCartItems = groupItemsByCategory(cart as CartItem[]);

    const categoryData: DaftarKategoriListInvoice[] = [
        // Array of objects conforming to DaftarKategoriListInvoice structure
    ];

    useEffect(() => {
        if (isOpenModalKonfirmasiBayar) {
            reset(initialValues);
        }
    }, [initialValues, isOpenModalKonfirmasiBayar, reset]);

    return (
        <Box position="relative">
            <Dialog
                maxWidth="lg"
                fullWidth
                fullScreen={fullScreen || isTabletScreen}
                open={isOpenModalKonfirmasiBayar}
                onClose={() => {
                    closeModalKonfirmasiBayar();
                }}
                scroll="paper"
                PaperProps={{
                    sx: {
                        borderRadius: 1,
                    },
                }}
            >
                <DialogTitle>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <IconButton onClick={closeModalKonfirmasiBayar}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="h6" fontWeight="bold">
                            Konfirmasi Pembayaran
                        </Typography>
                    </Stack>
                </DialogTitle>
                {/* <Divider flexItem /> */}
                <DialogContent
                    sx={{
                        paddingLeft: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: fullScreen ? "250px" : 0,
                    }}
                >
                    <Stack direction={{ xs: "column-reverse", md: "row" }}>
                        <Grid
                            item
                            xs={12}
                            lg={6}
                            paddingX={3}
                            paddingBottom={4}
                            height={
                                fullScreen
                                    ? undefined
                                    : isTabletScreen
                                    ? "calc(100vh - 72px)"
                                    : "calc(90vh - 72px)"
                            }
                            sx={{ overflowY: fullScreen ? undefined : "auto" }}
                        >
                            <Box
                                padding={2}
                                border={1}
                                borderColor="#d4d4d4"
                                borderRadius={2}
                                marginBottom={2}
                            >
                                <Typography
                                    variant="subtitle1"
                                    color="#000000"
                                    fontWeight="bold"
                                    marginBottom={2}
                                >
                                    Metode Pembayaran
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <Button
                                            fullWidth
                                            variant={
                                                toggleModePembayaran ===
                                                ModePembayaran.TUNAI
                                                    ? "contained"
                                                    : "outlined"
                                            }
                                            onClick={pilihTunai}
                                            sx={{ borderRadius: 4 }}
                                        >
                                            <Stack alignItems="center">
                                                <IconContext.Provider
                                                    value={{
                                                        size: "56px",
                                                    }}
                                                >
                                                    <GiMoneyStack />
                                                </IconContext.Provider>
                                                Tunai
                                            </Stack>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Stack
                                        // component={
                                        //     warehouseData?.isPro === 0
                                        //         ? Link
                                        //         : Stack
                                        // }
                                        // underline="none"
                                        // onClick={() => {
                                        //     if (
                                        //         warehouseData?.isPro === 1
                                        //     ) {
                                        //         return;
                                        //     } else {
                                        //         setIsOpenModalAlertPro(
                                        //             true,
                                        //         );
                                        //     }
                                        // }}
                                        // sx={{
                                        //     cursor:
                                        //         warehouseData?.isPro === 0
                                        //             ? "pointer"
                                        //             : undefined,
                                        // }}
                                        >
                                            <Button
                                                // disabled={
                                                //     warehouseData?.isPro !== 1 ||
                                                //     metodePembayaran?.length === 0
                                                // }
                                                fullWidth
                                                variant={
                                                    toggleModePembayaran ===
                                                    ModePembayaran.TRANSFER
                                                        ? "contained"
                                                        : "outlined"
                                                }
                                                onClick={() => {
                                                    // if (
                                                    //     warehouseData?.isPro ===
                                                    //     1
                                                    // ) {
                                                    pilihTransfer();
                                                    // }
                                                }}
                                                sx={{ borderRadius: 4 }}
                                            >
                                                <Stack alignItems="center">
                                                    <IconContext.Provider
                                                        value={{
                                                            size: "56px",
                                                        }}
                                                    >
                                                        <GiWallet />
                                                    </IconContext.Provider>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        gap={1}
                                                    >
                                                        Metode lain{" "}
                                                        {/* {warehouseData?.isPro ===
                                                        1 ? null : (
                                                            <Chip
                                                                label="PRO"
                                                                size="small"
                                                            />
                                                        )} */}
                                                    </Box>
                                                </Stack>
                                            </Button>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Grid container spacing={2} mb={2}>
                                <Grid item xs={12}>
                                    <Controller
                                        name="isPelangganBaru"
                                        control={control}
                                        render={({ field }) => (
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        size={
                                                            isTabletScreen
                                                                ? "small"
                                                                : undefined
                                                        }
                                                        {...field}
                                                    />
                                                }
                                                label="Pelanggan baru"
                                                componentsProps={{
                                                    typography: {
                                                        variant: "body2",
                                                        fontSize: isTabletScreen
                                                            ? "12px"
                                                            : undefined,
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        display: watchIsPelangganBaru
                                            ? "none"
                                            : undefined,
                                    }}
                                >
                                    <Typography>
                                        Pilih pelanggan (opsional)
                                    </Typography>
                                    <Controller
                                        name="pelanggan"
                                        control={control}
                                        // rules={{
                                        //     required:
                                        //         !watchIsPelangganBaru
                                        //             ? "Kolom wajib diisi"
                                        //             : undefined,
                                        // }}
                                        render={({ field, fieldState }) => (
                                            <Autocomplete
                                                disablePortal
                                                disableClearable
                                                loading={isLoadingPelanggan}
                                                options={
                                                    pelanggan?.content ?? []
                                                }
                                                getOptionLabel={(option) => {
                                                    return `${option.nama} (${option.noTelp})`;
                                                }}
                                                isOptionEqualToValue={(
                                                    option,
                                                    value,
                                                ) => option.id === value.id}
                                                size="small"
                                                value={field.value}
                                                onInputChange={(e) => {
                                                    if (e) {
                                                        const element =
                                                            e.target as HTMLInputElement;
                                                        setParamsPelanggan(
                                                            (prev) => ({
                                                                ...prev,
                                                                search: element.value,
                                                            }),
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                }}
                                                onChange={(
                                                    _event,
                                                    newPelanggan: ContentGetPelangganResponse | null,
                                                ) => {
                                                    field.onChange(
                                                        newPelanggan,
                                                    );
                                                }}
                                                fullWidth
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder={
                                                            "Pilih pelanggan (opsional)"
                                                        }
                                                        error={
                                                            !!fieldState?.error
                                                        }
                                                        helperText={
                                                            fieldState?.error &&
                                                            "Pilih satu pelanggan"
                                                        }
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        display: watchIsPelangganBaru
                                            ? undefined
                                            : "none",
                                    }}
                                >
                                    <Typography>Nama:</Typography>
                                    <Controller
                                        name="nama"
                                        control={control}
                                        rules={{
                                            required: watchIsPelangganBaru
                                                ? "Kolom wajib diisi"
                                                : undefined,
                                        }}
                                        render={({ field, fieldState }) => (
                                            <TextField
                                                placeholder="Contoh: Budi"
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                                error={!!fieldState.error}
                                                helperText={
                                                    fieldState.error
                                                        ? fieldState.error
                                                              .message
                                                        : ""
                                                }
                                                {...field}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    sx={{
                                        display: watchIsPelangganBaru
                                            ? undefined
                                            : "none",
                                    }}
                                >
                                    <Typography>No. Telepon:</Typography>
                                    <Controller
                                        name="noTelepon"
                                        control={control}
                                        rules={{
                                            required: watchIsPelangganBaru
                                                ? "Kolom wajib diisi"
                                                : undefined,
                                            pattern: {
                                                value: /^8[1-9][0-9]/,
                                                message:
                                                    "No. Telepon tidak valid, contoh: 831xxxx",
                                            },
                                            maxLength: {
                                                value: 13,
                                                message:
                                                    "No. Telepon terlalu panjang",
                                            },
                                            minLength: {
                                                value: 9,
                                                message:
                                                    "No. Telepon terlalu pendek",
                                            },
                                        }}
                                        render={({ field, fieldState }) => (
                                            <TextField
                                                placeholder="8123456789"
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                error={!!fieldState.error}
                                                helperText={
                                                    fieldState.error
                                                        ? fieldState.error
                                                              .message
                                                        : "No. Telepon tidak boleh sama dengan pelanggan lain"
                                                }
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            +62
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                {...field}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        display: watchIsPelangganBaru
                                            ? undefined
                                            : "none",
                                    }}
                                >
                                    <Typography>Alamat:</Typography>
                                    <Controller
                                        name="alamat"
                                        control={control}
                                        rules={{
                                            required: watchIsPelangganBaru
                                                ? "Kolom wajib diisi"
                                                : undefined,
                                        }}
                                        render={({ field, fieldState }) => (
                                            <TextField
                                                placeholder="Contoh: Jl. Merdeka Raya no. 2"
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                                multiline
                                                rows={2}
                                                error={!!fieldState.error}
                                                helperText={
                                                    fieldState.error
                                                        ? fieldState.error
                                                              .message
                                                        : ""
                                                }
                                                {...field}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            {toggleModePembayaran ===
                                ModePembayaran.TRANSFER && (
                                <Controller
                                    name="isPG"
                                    control={control}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    size={
                                                        isTabletScreen
                                                            ? "small"
                                                            : undefined
                                                    }
                                                    {...field}
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                        setValue(
                                                            "metodeBayar",
                                                            null,
                                                        );
                                                        setValue(
                                                            "selectedMetode",
                                                            null,
                                                        );
                                                    }}
                                                />
                                            }
                                            label="Gunakan payment gateway"
                                            componentsProps={{
                                                typography: {
                                                    variant: "body2",
                                                    fontSize: isTabletScreen
                                                        ? "12px"
                                                        : undefined,
                                                },
                                            }}
                                        />
                                    )}
                                />
                            )}
                            {toggleModePembayaran ===
                            ModePembayaran.TRANSFER ? (
                                watchIsPG ? (
                                    <Controller
                                        name="metodeBayar"
                                        control={control}
                                        rules={{
                                            required: watchIsPG
                                                ? "Kolom wajib diisi"
                                                : undefined,
                                        }}
                                        render={({ field, fieldState }) => (
                                            <>
                                                <Autocomplete
                                                    loading={
                                                        isLoadingPaymentMethod
                                                    }
                                                    options={
                                                        paymentMethod ?? []
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            error={
                                                                !!fieldState.error
                                                            }
                                                            helperText={
                                                                fieldState.error
                                                                    ? fieldState
                                                                          .error
                                                                          .message
                                                                    : ""
                                                            }
                                                            label="Pilih metode"
                                                            variant="outlined"
                                                        />
                                                    )}
                                                    getOptionLabel={(option) =>
                                                        option.paymentName
                                                    }
                                                    isOptionEqualToValue={(
                                                        option,
                                                        value,
                                                    ) =>
                                                        String(
                                                            option.paymentMethod,
                                                        ) ===
                                                        String(
                                                            value.paymentMethod,
                                                        )
                                                    }
                                                    size="small"
                                                    fullWidth
                                                    value={field.value}
                                                    onChange={(
                                                        _event,
                                                        newKategori: PaymentMethodData | null,
                                                    ) => {
                                                        field.onChange(
                                                            newKategori,
                                                        );
                                                    }}
                                                    sx={{ marginBottom: 2 }}
                                                />
                                            </>
                                        )}
                                    />
                                ) : metodePembayaran?.length !== 0 ? (
                                    <Box>
                                        <Controller
                                            name="selectedMetode"
                                            control={control}
                                            rules={{
                                                required: !watchIsPG
                                                    ? "Kolom wajib diisi"
                                                    : undefined,
                                            }}
                                            render={({ field, fieldState }) => (
                                                <>
                                                    <Autocomplete
                                                        loading={
                                                            isLoadingMetodePembayaran
                                                        }
                                                        options={
                                                            metodePembayaran ??
                                                            []
                                                        }
                                                        renderInput={(
                                                            params,
                                                        ) => (
                                                            <TextField
                                                                {...params}
                                                                error={
                                                                    !!fieldState.error
                                                                }
                                                                helperText={
                                                                    fieldState.error
                                                                        ? fieldState
                                                                              .error
                                                                              .message
                                                                        : ""
                                                                }
                                                                label="Pilih metode"
                                                                variant="outlined"
                                                            />
                                                        )}
                                                        getOptionLabel={(
                                                            option,
                                                        ) => option.namaMetode}
                                                        isOptionEqualToValue={(
                                                            option,
                                                            value,
                                                        ) =>
                                                            String(
                                                                option.id,
                                                            ) ===
                                                            String(value.id)
                                                        }
                                                        size="small"
                                                        fullWidth
                                                        value={field.value}
                                                        onChange={(
                                                            _event,
                                                            newKategori: MetodePembayaranData | null,
                                                        ) => {
                                                            field.onChange(
                                                                newKategori,
                                                            );
                                                        }}
                                                        sx={{ marginBottom: 2 }}
                                                    />
                                                </>
                                            )}
                                        />
                                        {watchSelectedMetode && (
                                            <Stack alignItems="center">
                                                {watchSelectedMetode.gambar && (
                                                    <img
                                                        src={
                                                            watchSelectedMetode.gambar ??
                                                            ""
                                                        }
                                                        alt="qrcode"
                                                        width={250}
                                                        height={250}
                                                    />
                                                )}
                                                <Typography>
                                                    a/n{" "}
                                                    {
                                                        watchSelectedMetode.namaPemegang
                                                    }
                                                </Typography>
                                                <Typography fontWeight="bold">
                                                    {
                                                        watchSelectedMetode.noTujuan
                                                    }
                                                </Typography>
                                                <Stack
                                                    marginTop={2}
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={2}
                                                >
                                                    <Typography>
                                                        Pilih tipe struk
                                                    </Typography>
                                                    <ToggleButtonGroup
                                                        value={tipeStrukTagihan}
                                                        exclusive
                                                        size="small"
                                                        onChange={
                                                            handleTipeStrukTagihan
                                                        }
                                                    >
                                                        <ToggleButton
                                                            value={
                                                                TipeStruk.Mobile
                                                            }
                                                            sx={{
                                                                display: "flex",
                                                                paddingX: 2,
                                                                textTransform:
                                                                    "none",
                                                            }}
                                                        >
                                                            <b>A8 58mm</b>
                                                        </ToggleButton>
                                                        <ToggleButton
                                                            value={
                                                                TipeStruk.Mobile80
                                                            }
                                                            sx={{
                                                                display: "flex",
                                                                paddingX: 2,
                                                                textTransform:
                                                                    "none",
                                                            }}
                                                        >
                                                            <b>A8 80mm</b>
                                                        </ToggleButton>
                                                        <ToggleButton
                                                            value={TipeStruk.PC}
                                                            sx={{
                                                                display: "flex",
                                                                paddingX: 2,
                                                                textTransform:
                                                                    "none",
                                                            }}
                                                        >
                                                            <b>A4</b>
                                                        </ToggleButton>
                                                    </ToggleButtonGroup>
                                                </Stack>
                                                {tipeStrukTagihan ===
                                                    TipeStruk.Mobile ||
                                                tipeStrukTagihan ===
                                                    TipeStruk.Mobile80 ? (
                                                    <BlobProvider
                                                        document={
                                                            <PrintStrukPdf
                                                                is80mm={
                                                                    tipeStrukTagihan ===
                                                                    TipeStruk.Mobile80
                                                                }
                                                                namaToko={String(
                                                                    warehouseData?.nama,
                                                                )}
                                                                alamatToko={String(
                                                                    warehouseData?.alamatToko,
                                                                )}
                                                                gambarToko={
                                                                    warehouseData?.gambarTokoBW ===
                                                                    null
                                                                        ? undefined
                                                                        : warehouseData?.gambarTokoBW
                                                                }
                                                                telpToko={
                                                                    warehouseData?.noTelp
                                                                }
                                                                tanggalTransaksi={
                                                                    now
                                                                }
                                                                transaksiKe={String(
                                                                    transaksiKe,
                                                                )}
                                                                kasir={
                                                                    props.kasir
                                                                }
                                                                sales={
                                                                    props.sales
                                                                        ?.nama ===
                                                                    undefined
                                                                        ? null
                                                                        : props
                                                                              .sales
                                                                              .nama
                                                                }
                                                                total={
                                                                    props.totalTagihan
                                                                }
                                                                cart={cart}
                                                                category={
                                                                    categoryData
                                                                }
                                                                groupByKategori={
                                                                    groupByKategori
                                                                }
                                                                diskon={
                                                                    props.diskon
                                                                }
                                                                pajak={
                                                                    props.pajak
                                                                }
                                                                // pajakPersen={
                                                                //     warehouseData?.pajak
                                                                // }
                                                                belumLunas={
                                                                    true
                                                                }
                                                                qr={
                                                                    watchSelectedMetode.gambar ??
                                                                    ""
                                                                }
                                                                isPro={Number(
                                                                    1,
                                                                )}
                                                                namaMetode={
                                                                    watchSelectedMetode &&
                                                                    toggleModePembayaran ===
                                                                        ModePembayaran.TRANSFER
                                                                        ? watchSelectedMetode.namaMetode
                                                                        : "Tunai"
                                                                }
                                                                // html={
                                                                //     findCustomStruk &&
                                                                //     findCustomStruk.html !==
                                                                //         null
                                                                //         ? findCustomStruk?.html
                                                                //         : undefined
                                                                // }
                                                                keterangan={
                                                                    props.keteranganBeli
                                                                }
                                                                noMetode={
                                                                    watchSelectedMetode.noTujuan
                                                                }
                                                                fee={
                                                                    watchMetodeBayar?.totalFee
                                                                        ? Number(
                                                                              watchMetodeBayar?.totalFee,
                                                                          )
                                                                        : null
                                                                }
                                                            />
                                                        }
                                                    >
                                                        {({
                                                            blob,
                                                            url,
                                                            loading,
                                                            error,
                                                        }) => {
                                                            return (
                                                                <LoadingButton
                                                                    variant="outlined"
                                                                    loading={
                                                                        loading
                                                                    }
                                                                    loadingPosition="center"
                                                                    startIcon={
                                                                        <Print />
                                                                    }
                                                                    href={
                                                                        url ??
                                                                        ""
                                                                    }
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    sx={{
                                                                        marginTop: 2,
                                                                    }}
                                                                >
                                                                    Cetak
                                                                    Tagihan
                                                                </LoadingButton>
                                                            );
                                                        }}
                                                    </BlobProvider>
                                                ) : (
                                                    <BlobProvider
                                                        document={
                                                            <PrintStrukA4
                                                                warehouseData={
                                                                    warehouseData
                                                                }
                                                                tanggalTransaksi={
                                                                    now
                                                                }
                                                                transaksiKe={String(
                                                                    transaksiKe,
                                                                )}
                                                                kasir={
                                                                    props.kasir
                                                                }
                                                                sales={
                                                                    props.sales
                                                                        ?.nama ===
                                                                    undefined
                                                                        ? null
                                                                        : props
                                                                              .sales
                                                                              .nama
                                                                }
                                                                total={
                                                                    props.totalTagihan
                                                                }
                                                                cart={cart}
                                                                category={
                                                                    categoryData
                                                                }
                                                                groupByKategori={
                                                                    groupByKategori
                                                                }
                                                                diskon={
                                                                    props.diskon
                                                                }
                                                                pajak={
                                                                    props.pajak
                                                                }
                                                                // pajakPersen={
                                                                //     warehouseData?.pajak
                                                                // }
                                                                belumLunas={
                                                                    true
                                                                }
                                                                namaMetode={
                                                                    watchSelectedMetode &&
                                                                    toggleModePembayaran ===
                                                                        ModePembayaran.TRANSFER
                                                                        ? watchSelectedMetode.namaMetode
                                                                        : "Tunai"
                                                                }
                                                                // html={
                                                                //     findCustomStruk &&
                                                                //     findCustomStruk.html !==
                                                                //         null
                                                                //         ? findCustomStruk?.html
                                                                //         : undefined
                                                                // }
                                                                keterangan={
                                                                    props.keteranganBeli
                                                                }
                                                                namaPemegang={
                                                                    watchSelectedMetode?.namaPemegang ??
                                                                    null
                                                                }
                                                                nomorTujuan={
                                                                    watchSelectedMetode?.noTujuan ??
                                                                    null
                                                                }
                                                                qr={
                                                                    watchSelectedMetode?.gambar
                                                                }
                                                                fee={
                                                                    watchMetodeBayar?.totalFee
                                                                        ? Number(
                                                                              watchMetodeBayar?.totalFee,
                                                                          )
                                                                        : null
                                                                }
                                                            />
                                                        }
                                                    >
                                                        {({
                                                            blob,
                                                            url,
                                                            loading,
                                                            error,
                                                        }) => {
                                                            return (
                                                                <LoadingButton
                                                                    variant="outlined"
                                                                    loading={
                                                                        loading
                                                                    }
                                                                    loadingPosition="center"
                                                                    startIcon={
                                                                        <Print />
                                                                    }
                                                                    href={
                                                                        url ??
                                                                        ""
                                                                    }
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    sx={{
                                                                        marginTop: 2,
                                                                    }}
                                                                >
                                                                    Cetak
                                                                    Tagihan
                                                                </LoadingButton>
                                                            );
                                                        }}
                                                    </BlobProvider>
                                                )}
                                            </Stack>
                                        )}
                                    </Box>
                                ) : null
                            ) : null}
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            lg={6}
                            borderLeft="1px solid #d4d4d4"
                            borderRadius="10px"
                        >
                            {/* <Divider flexItem /> */}
                            <Box
                                display="grid"
                                gridTemplateRows="auto 1fr auto"
                                height={
                                    fullScreen
                                        ? undefined
                                        : isTabletScreen
                                        ? "calc(100vh - 72px)"
                                        : "calc(90vh - 72px)"
                                }
                            >
                                <Stack
                                    direction="row"
                                    paddingLeft={3}
                                    paddingRight={4}
                                    paddingY={2}
                                    borderBottom="1px solid #d4d4d4"
                                    borderTop="1px solid #d4d4d4"
                                    borderRadius="10px 0 0 0"
                                >
                                    <Grid container spacing={2}>
                                        <Grid item>
                                            <Typography
                                                variant="subtitle2"
                                                color="#A1A1AA"
                                            >
                                                Tanggal
                                            </Typography>
                                            <Typography
                                                variant="subtitle2"
                                                color="black"
                                            >
                                                {now}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography
                                                variant="subtitle2"
                                                color="#A1A1AA"
                                            >
                                                Nama Kasir
                                            </Typography>
                                            <Typography
                                                variant="subtitle2"
                                                color="black"
                                            >
                                                {user?.namaLengkap}
                                            </Typography>
                                        </Grid>
                                        {!!props.sales && (
                                            <Grid item>
                                                <Typography
                                                    variant="subtitle2"
                                                    color="#A1A1AA"
                                                >
                                                    Nama Sales
                                                </Typography>
                                                <Typography
                                                    variant="subtitle2"
                                                    color="black"
                                                >
                                                    {props.sales.nama}
                                                </Typography>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Stack>

                                <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    marginTop={1}
                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={groupByKategori}
                                                onChange={
                                                    handleCheckboxKategori
                                                }
                                            />
                                        }
                                        label="Group by Kategori"
                                        sx={{ height: "fit-content" }}
                                    />
                                </Box>

                                <DialogContent
                                    sx={{
                                        paddingBottom: 2,
                                    }}
                                >
                                    {groupByKategori ? (
                                        <Stack direction="column" spacing={1}>
                                            {cart && cart.length > 0 ? (
                                                Object.entries(
                                                    groupedCartItems,
                                                ).map(
                                                    (
                                                        [category, items],
                                                        idx,
                                                    ) => (
                                                        <Box key={String(idx)}>
                                                            <Stack
                                                                marginTop={2}
                                                                marginBottom={1}
                                                            >
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    fontWeight="700"
                                                                    fontSize={
                                                                        18
                                                                    }
                                                                >
                                                                    {truncate(
                                                                        category,
                                                                        20,
                                                                    )}
                                                                </Typography>
                                                            </Stack>
                                                            {items.map(
                                                                (
                                                                    rows,
                                                                    itemIdx,
                                                                ) => (
                                                                    <Stack
                                                                        key={String(
                                                                            itemIdx,
                                                                        )}
                                                                        direction="row"
                                                                        justifyContent="space-between"
                                                                        marginLeft={
                                                                            2
                                                                        }
                                                                    >
                                                                        <Box width="50%">
                                                                            <Box>
                                                                                <Tooltip
                                                                                    title={
                                                                                        rows.namaBarang
                                                                                    }
                                                                                >
                                                                                    <Typography
                                                                                        variant={
                                                                                            isTabletScreen
                                                                                                ? "body2"
                                                                                                : "subtitle1"
                                                                                        }
                                                                                        fontWeight={
                                                                                            600
                                                                                        }
                                                                                        color="black"
                                                                                    >
                                                                                        {truncate(
                                                                                            rows.namaBarang,
                                                                                            20,
                                                                                        )}
                                                                                    </Typography>
                                                                                </Tooltip>
                                                                                <Typography>
                                                                                    Rp.{" "}
                                                                                    {toRibuan(
                                                                                        rows.harga,
                                                                                    )}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                        <Box display="flex">
                                                                            <Typography
                                                                                variant={
                                                                                    isTabletScreen
                                                                                        ? "body2"
                                                                                        : "subtitle1"
                                                                                }
                                                                                fontWeight={
                                                                                    600
                                                                                }
                                                                                color="black"
                                                                            >
                                                                                {
                                                                                    rows.qty
                                                                                }

                                                                                x
                                                                            </Typography>
                                                                        </Box>
                                                                        <Stack
                                                                            direction="row"
                                                                            width="30%"
                                                                            display="flex"
                                                                            justifyContent="flex-end"
                                                                        >
                                                                            <Typography
                                                                                display="flex"
                                                                                variant={
                                                                                    isTabletScreen
                                                                                        ? "body2"
                                                                                        : "subtitle1"
                                                                                }
                                                                                fontWeight={
                                                                                    600
                                                                                }
                                                                                color="black"
                                                                                textAlign="end"
                                                                            >
                                                                                Rp.{" "}
                                                                                {toRibuan(
                                                                                    rows.harga *
                                                                                        rows.qty,
                                                                                )}
                                                                            </Typography>
                                                                        </Stack>
                                                                    </Stack>
                                                                ),
                                                            )}
                                                        </Box>
                                                    ),
                                                )
                                            ) : (
                                                <Typography variant="h6">
                                                    Barang tidak ditemukan
                                                </Typography>
                                            )}
                                        </Stack>
                                    ) : (
                                        <Stack direction="column" spacing={1}>
                                            {cart ? (
                                                cart.map((rows, idx) => (
                                                    <Box key={String(idx)}>
                                                        <Stack
                                                            direction="row"
                                                            justifyContent="space-between"
                                                        >
                                                            <Box width="50%">
                                                                <Box>
                                                                    <Tooltip
                                                                        title={
                                                                            rows.namaBarang
                                                                        }
                                                                    >
                                                                        <Typography
                                                                            variant={
                                                                                isTabletScreen
                                                                                    ? "body2"
                                                                                    : "subtitle1"
                                                                            }
                                                                            fontWeight={
                                                                                600
                                                                            }
                                                                            color="black"
                                                                        >
                                                                            {truncate(
                                                                                rows.namaBarang,
                                                                                20,
                                                                            )}
                                                                        </Typography>
                                                                    </Tooltip>
                                                                    <Typography>
                                                                        Rp.{" "}
                                                                        {toRibuan(
                                                                            rows.harga,
                                                                        )}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                            <Box display="flex">
                                                                <Typography
                                                                    variant={
                                                                        isTabletScreen
                                                                            ? "body2"
                                                                            : "subtitle1"
                                                                    }
                                                                    fontWeight={
                                                                        600
                                                                    }
                                                                    color="black"
                                                                >
                                                                    {rows.qty}x
                                                                </Typography>
                                                            </Box>
                                                            <Stack
                                                                direction="row"
                                                                width="30%"
                                                                display="flex"
                                                                justifyContent="flex-end"
                                                            >
                                                                <Typography
                                                                    display="flex"
                                                                    variant={
                                                                        isTabletScreen
                                                                            ? "body2"
                                                                            : "subtitle1"
                                                                    }
                                                                    fontWeight={
                                                                        600
                                                                    }
                                                                    color="black"
                                                                    textAlign="end"
                                                                >
                                                                    Rp.{" "}
                                                                    {toRibuan(
                                                                        rows.harga *
                                                                            rows.qty,
                                                                    )}
                                                                </Typography>
                                                            </Stack>
                                                        </Stack>
                                                    </Box>
                                                ))
                                            ) : (
                                                <Typography variant="h6">
                                                    Barang tidak ditemukan
                                                </Typography>
                                            )}
                                        </Stack>
                                    )}

                                    <Box
                                        marginY={2}
                                        padding={2}
                                        border={1}
                                        borderColor="#d4d4d4"
                                        borderRadius={2}
                                    >
                                        <Typography
                                            marginBottom={1}
                                            variant={
                                                isTabletScreen
                                                    ? "body2"
                                                    : "subtitle1"
                                            }
                                            color="#000000"
                                            fontWeight="bold"
                                        >
                                            Ringkasan Pembayaran
                                        </Typography>
                                        <Grid
                                            container
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={6}
                                                sm={3}
                                                md={4}
                                                lg={4}
                                            >
                                                <Typography
                                                    variant={
                                                        isTabletScreen
                                                            ? "body2"
                                                            : "subtitle1"
                                                    }
                                                    color="#404040"
                                                >
                                                    Subtotal Harga
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={3} xs={5}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    paddingX={1}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(totalHarga)}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            marginTop={1}
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={6}
                                                sm={4}
                                                md={5}
                                                lg={5}
                                            >
                                                <Typography
                                                    variant={
                                                        isTabletScreen
                                                            ? "body2"
                                                            : "subtitle1"
                                                    }
                                                    color="#404040"
                                                >
                                                    Diskon{" "}
                                                    {props.persentaseDiskon &&
                                                    props.persentaseDiskon > 0
                                                        ? `(${props.persentaseDiskon}%)`
                                                        : ""}
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={3} xs={5}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#FFF5EC"
                                                    paddingX={1}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(
                                                            props.diskon ?? 0,
                                                        )}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            marginTop={1}
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={6}
                                                sm={4}
                                                md={5}
                                                lg={5}
                                            >
                                                <Typography
                                                    variant={
                                                        isTabletScreen
                                                            ? "body2"
                                                            : "subtitle1"
                                                    }
                                                    color="#404040"
                                                >
                                                    Pajak{" "}
                                                    {props.persentasePajak &&
                                                    props.persentasePajak > 0
                                                        ? `(${props.persentasePajak}%)`
                                                        : ""}
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={3} xs={5}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#FFF5EC"
                                                    paddingX={1}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(
                                                            props.pajak ?? 0,
                                                        )}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        {watchMetodeBayar ? (
                                            <Grid
                                                container
                                                alignItems="center"
                                                marginTop={1}
                                                justifyContent="space-between"
                                            >
                                                <Grid
                                                    item
                                                    xs={6}
                                                    sm={3}
                                                    md={4}
                                                    lg={4}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#404040"
                                                    >
                                                        Biaya Admin
                                                    </Typography>
                                                </Grid>
                                                <Grid item lg={3} xs={5}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        bgcolor="#FFF5EC"
                                                        paddingX={1}
                                                    >
                                                        <Typography
                                                            variant={
                                                                isTabletScreen
                                                                    ? "body2"
                                                                    : "subtitle1"
                                                            }
                                                            color="#FB923C"
                                                            fontWeight="bold"
                                                        >
                                                            Rp.
                                                        </Typography>
                                                        <Typography
                                                            variant={
                                                                isTabletScreen
                                                                    ? "body2"
                                                                    : "subtitle1"
                                                            }
                                                            color="#FB923C"
                                                            fontWeight="bold"
                                                        >
                                                            {toRibuan(
                                                                watchMetodeBayar.totalFee,
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        ) : null}
                                        <Grid
                                            container
                                            alignItems="center"
                                            marginTop={1}
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={6}
                                                sm={3}
                                                md={4}
                                                lg={4}
                                            >
                                                <Typography
                                                    variant={
                                                        isTabletScreen
                                                            ? "body2"
                                                            : "subtitle1"
                                                    }
                                                    color="#404040"
                                                >
                                                    Total Tagihan
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={3} xs={5}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#E8F6ED"
                                                    paddingX={1}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#45A779"
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#45A779"
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(
                                                            props.totalTagihan +
                                                                (watchMetodeBayar &&
                                                                watchMetodeBayar.totalFee
                                                                    ? Number(
                                                                          watchMetodeBayar.totalFee,
                                                                      )
                                                                    : 0),
                                                        )}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            alignItems="center"
                                            marginTop={1}
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={6}
                                                sm={3}
                                                md={4}
                                                lg={4}
                                            >
                                                <Typography
                                                    variant={
                                                        isTabletScreen
                                                            ? "body2"
                                                            : "subtitle1"
                                                    }
                                                    color="#404040"
                                                >
                                                    Uang yang Dibayar
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={3} xs={5}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#FFF5EC"
                                                    paddingX={1}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        {watchIsPG
                                                            ? toRibuan(
                                                                  props.totalTagihan +
                                                                      (watchMetodeBayar &&
                                                                      watchMetodeBayar.totalFee
                                                                          ? Number(
                                                                                watchMetodeBayar.totalFee,
                                                                            )
                                                                          : 0),
                                                              )
                                                            : toRibuan(
                                                                  props.uangDibayar ??
                                                                      0,
                                                              )}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            alignItems="center"
                                            marginTop={1}
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={6}
                                                sm={3}
                                                md={4}
                                                lg={4}
                                            >
                                                <Typography
                                                    variant={
                                                        isTabletScreen
                                                            ? "body2"
                                                            : "subtitle1"
                                                    }
                                                    color="#404040"
                                                >
                                                    Kembalian
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={3} xs={5}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#FCEAEA"
                                                    paddingX={1}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#DC2626"
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#DC2626"
                                                        fontWeight="bold"
                                                    >
                                                        {watchIsPG
                                                            ? toRibuan(0)
                                                            : toRibuan(
                                                                  props.kembalian,
                                                              )}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        {watchSelectedMetode && (
                                            <Grid
                                                container
                                                alignItems="center"
                                                marginTop={1}
                                                justifyContent="space-between"
                                            >
                                                <Grid
                                                    item
                                                    xs={6}
                                                    sm={3}
                                                    md={4}
                                                    lg={4}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#404040"
                                                    >
                                                        Charge{" "}
                                                        {
                                                            watchSelectedMetode.namaMetode
                                                        }{" "}
                                                        {watchSelectedMetode
                                                            .charge.mode ===
                                                        "persen"
                                                            ? `(${watchSelectedMetode.charge.charge}%)`
                                                            : ""}
                                                    </Typography>
                                                </Grid>
                                                <Grid item lg={3} xs={5}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        paddingX={1}
                                                    >
                                                        <Typography
                                                            variant={
                                                                isTabletScreen
                                                                    ? "body2"
                                                                    : "subtitle1"
                                                            }
                                                            fontWeight="bold"
                                                        >
                                                            Rp.
                                                        </Typography>
                                                        <Typography
                                                            variant={
                                                                isTabletScreen
                                                                    ? "body2"
                                                                    : "subtitle1"
                                                            }
                                                            fontWeight="bold"
                                                        >
                                                            {watchSelectedMetode
                                                                .charge.mode ===
                                                            "persen"
                                                                ? toRibuan(
                                                                      (props.uangDibayar *
                                                                          Number(
                                                                              watchSelectedMetode
                                                                                  .charge
                                                                                  .charge,
                                                                          )) /
                                                                          100,
                                                                  )
                                                                : toRibuan(
                                                                      watchSelectedMetode
                                                                          .charge
                                                                          .charge,
                                                                  )}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        )}
                                        {props.keteranganBeli && (
                                            <Grid
                                                container
                                                alignItems="center"
                                                marginTop={1}
                                            >
                                                <Grid item xs={12}>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#404040"
                                                    >
                                                        Keterangan
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        disabled
                                                        multiline
                                                        rows={2}
                                                        fullWidth
                                                        value={
                                                            props.keteranganBeli
                                                        }
                                                        sx={{
                                                            "& .MuiOutlinedInput-input.Mui-disabled":
                                                                {
                                                                    color: "rgba(0, 0, 0, 0.87)",
                                                                    WebkitTextFillColor:
                                                                        "rgba(0, 0, 0, 0.87)",
                                                                },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Box>
                                </DialogContent>
                                <Grid
                                    container
                                    justifyContent="flex-end"
                                    display={fullScreen ? "none" : undefined}
                                >
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        <Box
                                            paddingTop={3}
                                            paddingLeft={3}
                                            display="flex"
                                            justifyContent="flex-start"
                                            borderTop={1}
                                            borderColor="#d4d4d4"
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={printStruk}
                                                        size={
                                                            isTabletScreen
                                                                ? "small"
                                                                : undefined
                                                        }
                                                        onChange={(
                                                            _,
                                                            checked,
                                                        ) => {
                                                            handlePrintStruk(
                                                                checked,
                                                            );
                                                        }}
                                                    />
                                                }
                                                label="Print struk"
                                                componentsProps={{
                                                    typography: {
                                                        fontSize: isTabletScreen
                                                            ? "12px"
                                                            : undefined,
                                                    },
                                                }}
                                                sx={{
                                                    height: "fit-content",
                                                }}
                                            />
                                            {printStruk && (
                                                <ToggleButtonGroup
                                                    value={tipeStruk}
                                                    exclusive
                                                    size="small"
                                                    onChange={handleTipeStruk}
                                                >
                                                    <ToggleButton
                                                        value={TipeStruk.Mobile}
                                                        sx={{
                                                            display: "flex",
                                                            paddingX: 2,
                                                            textTransform:
                                                                "none",
                                                        }}
                                                    >
                                                        <b>A8 58mm</b>
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={
                                                            TipeStruk.Mobile80
                                                        }
                                                        sx={{
                                                            display: "flex",
                                                            paddingX: 2,
                                                            textTransform:
                                                                "none",
                                                        }}
                                                    >
                                                        <b>A8 80mm</b>
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={TipeStruk.PC}
                                                        sx={{
                                                            display: "flex",
                                                            paddingX: 2,
                                                            textTransform:
                                                                "none",
                                                        }}
                                                    >
                                                        <b>A4</b>
                                                    </ToggleButton>
                                                </ToggleButtonGroup>
                                            )}
                                        </Box>
                                        <Box
                                            paddingLeft={3}
                                            display="flex"
                                            // justifyContent="flex-start"
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={kirimEmail}
                                                        size={
                                                            isTabletScreen
                                                                ? "small"
                                                                : undefined
                                                        }
                                                        onChange={(
                                                            _,
                                                            checked,
                                                        ) => {
                                                            handleKirimEmail(
                                                                checked,
                                                            );
                                                        }}
                                                    />
                                                }
                                                label="Kirim struk"
                                                componentsProps={{
                                                    typography: {
                                                        fontSize: isTabletScreen
                                                            ? "12px"
                                                            : undefined,
                                                    },
                                                }}
                                                sx={{
                                                    height: "fit-content",
                                                }}
                                            />
                                        </Box>
                                        {kirimEmail && (
                                            <Box paddingX={3}>
                                                <Grid container>
                                                    <Grid item xs={12} sm={6}>
                                                        <Stack
                                                            display="flex"
                                                            direction="row"
                                                            spacing={1}
                                                            sx={{
                                                                marginRight: 2,
                                                            }}
                                                        >
                                                            <Button
                                                                disabled={
                                                                    user &&
                                                                    !user.akses.transaksi.includes(
                                                                        12,
                                                                    )
                                                                }
                                                                size={
                                                                    isTabletScreen
                                                                        ? "small"
                                                                        : "medium"
                                                                }
                                                                fullWidth
                                                                variant={
                                                                    toggleKirimStruk ===
                                                                    "whatsapp"
                                                                        ? "contained"
                                                                        : "outlined"
                                                                }
                                                                onClick={() =>
                                                                    pilihWhatsapp()
                                                                }
                                                            >
                                                                Whatsapp
                                                            </Button>
                                                            <Button
                                                                disabled={
                                                                    user &&
                                                                    !user.akses.transaksi.includes(
                                                                        12,
                                                                    )
                                                                }
                                                                size={
                                                                    isTabletScreen
                                                                        ? "small"
                                                                        : "medium"
                                                                }
                                                                fullWidth
                                                                variant={
                                                                    toggleKirimStruk ===
                                                                    "email"
                                                                        ? "contained"
                                                                        : "outlined"
                                                                }
                                                                onClick={() =>
                                                                    pilihEmail()
                                                                }
                                                            >
                                                                Email
                                                            </Button>
                                                        </Stack>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            value={email}
                                                            size="small"
                                                            type="email"
                                                            fullWidth
                                                            sx={{
                                                                maxWidth: 300,
                                                            }}
                                                            placeholder={
                                                                toggleKirimStruk ===
                                                                "email"
                                                                    ? "Contoh: budi93@gmail.com"
                                                                    : "8316352725"
                                                            }
                                                            InputProps={{
                                                                startAdornment:
                                                                    toggleKirimStruk ===
                                                                        "whatsapp" && (
                                                                        <InputAdornment position="start">
                                                                            +62
                                                                        </InputAdornment>
                                                                    ),
                                                            }}
                                                            onChange={(
                                                                event: React.ChangeEvent<HTMLInputElement>,
                                                            ) =>
                                                                setEmail(
                                                                    event.target
                                                                        .value,
                                                                )
                                                            }
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        )}
                                        <Box
                                            marginTop={isTabletScreen ? 1 : 2}
                                            marginLeft={3}
                                            marginRight={3}
                                            marginBottom={
                                                isTabletScreen ? 2 : 4
                                            }
                                        >
                                            <Stack
                                                direction="column"
                                                display="flex"
                                                justifyContent="space-between"
                                                marginBottom={1}
                                                spacing={1}
                                            >
                                                <Stack
                                                    direction="row"
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        fontWeight="bold"
                                                    >
                                                        Total
                                                    </Typography>
                                                    <Box
                                                        bgcolor="#E8F6ED"
                                                        borderRadius={1}
                                                        paddingX={2}
                                                    >
                                                        <Typography
                                                            variant={
                                                                isTabletScreen
                                                                    ? "body2"
                                                                    : "subtitle1"
                                                            }
                                                            fontWeight="bold"
                                                            color="#45A779"
                                                        >
                                                            Rp.{" "}
                                                            {toRibuan(
                                                                props.totalTagihan +
                                                                    (watchMetodeBayar &&
                                                                    watchMetodeBayar.totalFee
                                                                        ? Number(
                                                                              watchMetodeBayar.totalFee,
                                                                          )
                                                                        : 0),
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                </Stack>
                                                <Stack
                                                    direction="row"
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        fontWeight="bold"
                                                    >
                                                        Kembalian
                                                    </Typography>
                                                    <Box
                                                        justifyContent="space-between"
                                                        bgcolor="#FCEAEA"
                                                        paddingX={2}
                                                        borderRadius={1}
                                                    >
                                                        <Typography
                                                            variant={
                                                                isTabletScreen
                                                                    ? "body2"
                                                                    : "subtitle1"
                                                            }
                                                            fontWeight="bold"
                                                            color="#DC2626"
                                                        >
                                                            Rp.{" "}
                                                            {watchIsPG
                                                                ? toRibuan(0)
                                                                : toRibuan(
                                                                      props.kembalian,
                                                                  )}
                                                        </Typography>
                                                    </Box>
                                                </Stack>
                                                {printStruk ? (
                                                    <BlobProvider
                                                        document={
                                                            tipeStruk ===
                                                                TipeStruk.Mobile ||
                                                            tipeStruk ===
                                                                TipeStruk.Mobile80 ? (
                                                                <PrintStrukPdf
                                                                    is80mm={
                                                                        tipeStruk ===
                                                                        TipeStruk.Mobile80
                                                                    }
                                                                    namaToko={String(
                                                                        warehouseData?.nama,
                                                                    )}
                                                                    alamatToko={String(
                                                                        warehouseData?.alamatToko,
                                                                    )}
                                                                    gambarToko={
                                                                        warehouseData?.gambarTokoBW ===
                                                                        null
                                                                            ? undefined
                                                                            : warehouseData?.gambarTokoBW
                                                                    }
                                                                    telpToko={
                                                                        warehouseData?.noTelp
                                                                    }
                                                                    tanggalTransaksi={
                                                                        now
                                                                    }
                                                                    transaksiKe={String(
                                                                        transaksiKe,
                                                                    )}
                                                                    kasir={
                                                                        props.kasir
                                                                    }
                                                                    sales={
                                                                        props
                                                                            .sales
                                                                            ?.nama ===
                                                                        undefined
                                                                            ? null
                                                                            : props
                                                                                  .sales
                                                                                  .nama
                                                                    }
                                                                    total={
                                                                        props.totalTagihan
                                                                    }
                                                                    cart={cart}
                                                                    category={
                                                                        categoryData
                                                                    }
                                                                    groupByKategori={
                                                                        groupByKategori
                                                                    }
                                                                    diskon={
                                                                        props.diskon
                                                                    }
                                                                    pajak={
                                                                        props.pajak
                                                                    }
                                                                    // pajakPersen={
                                                                    //     warehouseData?.pajak
                                                                    // }
                                                                    tunai={
                                                                        watchIsPG
                                                                            ? props.totalTagihan
                                                                            : Number(
                                                                                  props.uangDibayar,
                                                                              )
                                                                    }
                                                                    kembalian={
                                                                        watchIsPG
                                                                            ? 0
                                                                            : props.kembalian
                                                                    }
                                                                    isPro={Number(
                                                                        1,
                                                                    )}
                                                                    namaMetode={
                                                                        watchSelectedMetode &&
                                                                        toggleModePembayaran ===
                                                                            ModePembayaran.TRANSFER
                                                                            ? watchSelectedMetode.namaMetode
                                                                            : "Tunai"
                                                                    }
                                                                    // html={
                                                                    //     findCustomStruk &&
                                                                    //     findCustomStruk.html !==
                                                                    //         null
                                                                    //         ? findCustomStruk?.html
                                                                    //         : undefined
                                                                    // }
                                                                    keterangan={
                                                                        props.keteranganBeli
                                                                    }
                                                                    noMetode={
                                                                        watchSelectedMetode?.noTujuan ??
                                                                        null
                                                                    }
                                                                    fee={
                                                                        watchMetodeBayar?.totalFee
                                                                            ? Number(
                                                                                  watchMetodeBayar?.totalFee,
                                                                              )
                                                                            : null
                                                                    }
                                                                />
                                                            ) : (
                                                                <PrintStrukA4
                                                                    warehouseData={
                                                                        warehouseData
                                                                    }
                                                                    tanggalTransaksi={
                                                                        now
                                                                    }
                                                                    transaksiKe={String(
                                                                        transaksiKe,
                                                                    )}
                                                                    kasir={
                                                                        props.kasir
                                                                    }
                                                                    sales={
                                                                        props
                                                                            .sales
                                                                            ?.nama ===
                                                                        undefined
                                                                            ? null
                                                                            : props
                                                                                  .sales
                                                                                  .nama
                                                                    }
                                                                    total={
                                                                        props.totalTagihan
                                                                    }
                                                                    cart={cart}
                                                                    category={
                                                                        categoryData
                                                                    }
                                                                    groupByKategori={
                                                                        groupByKategori
                                                                    }
                                                                    diskon={
                                                                        props.diskon
                                                                    }
                                                                    pajak={
                                                                        props.pajak
                                                                    }
                                                                    // pajakPersen={
                                                                    //     warehouseData?.pajak
                                                                    // }
                                                                    tunai={
                                                                        watchIsPG
                                                                            ? props.totalTagihan
                                                                            : Number(
                                                                                  props.uangDibayar,
                                                                              )
                                                                    }
                                                                    kembalian={
                                                                        watchIsPG
                                                                            ? 0
                                                                            : props.kembalian
                                                                    }
                                                                    namaMetode={
                                                                        watchSelectedMetode &&
                                                                        toggleModePembayaran ===
                                                                            ModePembayaran.TRANSFER
                                                                            ? watchSelectedMetode.namaMetode
                                                                            : "Tunai"
                                                                    }
                                                                    // html={
                                                                    //     findCustomStruk &&
                                                                    //     findCustomStruk.html !==
                                                                    //         null
                                                                    //         ? findCustomStruk?.html
                                                                    //         : undefined
                                                                    // }
                                                                    keterangan={
                                                                        props.keteranganBeli
                                                                    }
                                                                    namaPemegang={
                                                                        watchSelectedMetode?.namaPemegang ??
                                                                        null
                                                                    }
                                                                    nomorTujuan={
                                                                        watchSelectedMetode?.noTujuan ??
                                                                        null
                                                                    }
                                                                    qr={
                                                                        watchSelectedMetode?.gambar
                                                                    }
                                                                    fee={
                                                                        watchMetodeBayar?.totalFee
                                                                            ? Number(
                                                                                  watchMetodeBayar?.totalFee,
                                                                              )
                                                                            : null
                                                                    }
                                                                />
                                                            )
                                                        }
                                                    >
                                                        {({
                                                            blob,
                                                            url,
                                                            loading,
                                                            error,
                                                        }) => {
                                                            return (
                                                                <LoadingButton
                                                                    loading={
                                                                        loading ||
                                                                        isButtonLoading
                                                                    }
                                                                    loadingPosition="center"
                                                                    variant="contained"
                                                                    fullWidth
                                                                    size={
                                                                        isTabletScreen
                                                                            ? "medium"
                                                                            : "large"
                                                                    }
                                                                    // href={
                                                                    //     url ??
                                                                    //     ""
                                                                    // }
                                                                    // target="_blank"
                                                                    // rel="noreferrer"
                                                                    onClick={(
                                                                        e,
                                                                    ) => {
                                                                        if (
                                                                            blob
                                                                        ) {
                                                                            const blobFile =
                                                                                new File(
                                                                                    [
                                                                                        blob,
                                                                                    ],
                                                                                    `Invoice_${warehouseData?.nama}_${now}.pdf`,
                                                                                    {
                                                                                        type: "application/pdf",
                                                                                    },
                                                                                );
                                                                            const invoiceUrl =
                                                                                window.URL.createObjectURL(
                                                                                    blobFile,
                                                                                );
                                                                            console.log(
                                                                                invoiceUrl,
                                                                            );
                                                                            window.open(
                                                                                invoiceUrl,
                                                                            );
                                                                            onSubmit(
                                                                                e,
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    Bayar
                                                                </LoadingButton>
                                                            );
                                                        }}
                                                    </BlobProvider>
                                                ) : (
                                                    <LoadingButton
                                                        loading={
                                                            isButtonLoading
                                                        }
                                                        loadingPosition="center"
                                                        variant="contained"
                                                        fullWidth
                                                        size={
                                                            isTabletScreen
                                                                ? "medium"
                                                                : "large"
                                                        }
                                                        onClick={onSubmit}
                                                    >
                                                        Bayar
                                                    </LoadingButton>
                                                )}
                                            </Stack>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Stack>
                    <Grid
                        container
                        justifyContent="flex-end"
                        display={fullScreen ? undefined : "none"}
                        position="fixed"
                        bottom={0}
                        bgcolor="#fff"
                        zIndex={1}
                    >
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Box
                                paddingTop={3}
                                paddingLeft={3}
                                display="flex"
                                justifyContent="flex-start"
                                borderTop={1}
                                borderColor="#d4d4d4"
                            >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={printStruk}
                                            onChange={(_, checked) => {
                                                handlePrintStruk(checked);
                                            }}
                                        />
                                    }
                                    label="Print struk"
                                    sx={{
                                        height: "fit-content",
                                    }}
                                />
                                {printStruk && (
                                    <ToggleButtonGroup
                                        value={tipeStruk}
                                        exclusive
                                        size="small"
                                        onChange={handleTipeStruk}
                                    >
                                        <ToggleButton
                                            value={TipeStruk.Mobile}
                                            sx={{
                                                display: "flex",
                                                paddingX: 2,
                                                textTransform: "none",
                                            }}
                                        >
                                            <b>A8 58mm</b>
                                        </ToggleButton>
                                        <ToggleButton
                                            value={TipeStruk.Mobile80}
                                            sx={{
                                                display: "flex",
                                                paddingX: 2,
                                                textTransform: "none",
                                            }}
                                        >
                                            <b>A8 80mm</b>
                                        </ToggleButton>
                                        <ToggleButton
                                            value={TipeStruk.PC}
                                            sx={{
                                                display: "flex",
                                                paddingX: 2,
                                                textTransform: "none",
                                            }}
                                        >
                                            <b>A4</b>
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                )}
                            </Box>
                            <Box
                                paddingLeft={3}
                                display="flex"
                                // justifyContent="flex-start"
                            >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={kirimEmail}
                                            onChange={(_, checked) => {
                                                handleKirimEmail(checked);
                                            }}
                                        />
                                    }
                                    label="Kirim struk"
                                    sx={{
                                        height: "fit-content",
                                    }}
                                />
                            </Box>
                            {kirimEmail && (
                                <Box paddingX={3}>
                                    <Grid container rowSpacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Stack
                                                display="flex"
                                                direction="row"
                                                spacing={1}
                                                sx={{
                                                    marginRight: 2,
                                                }}
                                            >
                                                <Button
                                                    disabled={
                                                        user &&
                                                        !user.akses.transaksi.includes(
                                                            12,
                                                        )
                                                    }
                                                    size="medium"
                                                    fullWidth
                                                    variant={
                                                        toggleKirimStruk ===
                                                        "whatsapp"
                                                            ? "contained"
                                                            : "outlined"
                                                    }
                                                    onClick={() =>
                                                        pilihWhatsapp()
                                                    }
                                                >
                                                    Whatsapp
                                                </Button>
                                                <Button
                                                    disabled={
                                                        user &&
                                                        !user.akses.transaksi.includes(
                                                            12,
                                                        )
                                                    }
                                                    size="medium"
                                                    fullWidth
                                                    variant={
                                                        toggleKirimStruk ===
                                                        "email"
                                                            ? "contained"
                                                            : "outlined"
                                                    }
                                                    onClick={() => pilihEmail()}
                                                >
                                                    Email
                                                </Button>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                value={email}
                                                size="small"
                                                type="email"
                                                fullWidth
                                                sx={{ maxWidth: 300 }}
                                                placeholder={
                                                    toggleKirimStruk === "email"
                                                        ? "Contoh: budi93@gmail.com"
                                                        : "8316352725"
                                                }
                                                InputProps={{
                                                    startAdornment:
                                                        toggleKirimStruk ===
                                                            "whatsapp" && (
                                                            <InputAdornment position="start">
                                                                +62
                                                            </InputAdornment>
                                                        ),
                                                }}
                                                onChange={(
                                                    event: React.ChangeEvent<HTMLInputElement>,
                                                ) =>
                                                    setEmail(event.target.value)
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            )}
                            <Box
                                marginTop={2}
                                marginLeft={3}
                                marginRight={3}
                                marginBottom={4}
                            >
                                <Stack
                                    direction="column"
                                    display="flex"
                                    justifyContent="space-between"
                                    marginBottom={1}
                                    spacing={1}
                                >
                                    <Stack
                                        direction="row"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between"
                                    >
                                        <Typography
                                            variant="subtitle1"
                                            fontWeight="bold"
                                        >
                                            Total
                                        </Typography>
                                        <Box
                                            bgcolor="#E8F6ED"
                                            borderRadius={1}
                                            paddingX={2}
                                        >
                                            <Typography
                                                variant="subtitle1"
                                                fontWeight="bold"
                                                color="#45A779"
                                            >
                                                Rp.{" "}
                                                {toRibuan(
                                                    props.totalTagihan +
                                                        (watchMetodeBayar &&
                                                        watchMetodeBayar.totalFee
                                                            ? Number(
                                                                  watchMetodeBayar.totalFee,
                                                              )
                                                            : 0),
                                                )}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                    <Stack
                                        direction="row"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between"
                                    >
                                        <Typography
                                            variant="subtitle1"
                                            fontWeight="bold"
                                        >
                                            Kembalian
                                        </Typography>
                                        <Box
                                            justifyContent="space-between"
                                            bgcolor="#FCEAEA"
                                            paddingX={2}
                                            borderRadius={1}
                                        >
                                            <Typography
                                                variant="subtitle1"
                                                fontWeight="bold"
                                                color="#DC2626"
                                            >
                                                Rp.{" "}
                                                {watchIsPG
                                                    ? 0
                                                    : toRibuan(props.kembalian)}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                </Stack>
                                {printStruk ? (
                                    <BlobProvider
                                        document={
                                            tipeStruk === TipeStruk.Mobile ||
                                            tipeStruk === TipeStruk.Mobile80 ? (
                                                <PrintStrukPdf
                                                    is80mm={
                                                        tipeStruk ===
                                                        TipeStruk.Mobile80
                                                    }
                                                    namaToko={String(
                                                        warehouseData?.nama,
                                                    )}
                                                    alamatToko={String(
                                                        warehouseData?.alamatToko,
                                                    )}
                                                    gambarToko={
                                                        warehouseData?.gambarTokoBW ===
                                                        null
                                                            ? undefined
                                                            : warehouseData?.gambarTokoBW
                                                    }
                                                    telpToko={
                                                        warehouseData?.noTelp
                                                    }
                                                    tanggalTransaksi={now}
                                                    transaksiKe={String(
                                                        transaksiKe,
                                                    )}
                                                    kasir={props.kasir}
                                                    sales={
                                                        props.sales?.nama ===
                                                        undefined
                                                            ? null
                                                            : props.sales.nama
                                                    }
                                                    total={props.totalTagihan}
                                                    cart={cart}
                                                    category={categoryData}
                                                    groupByKategori={
                                                        groupByKategori
                                                    }
                                                    diskon={props.diskon}
                                                    pajak={props.pajak}
                                                    // pajakPersen={
                                                    //     warehouseData?.pajak
                                                    // }
                                                    tunai={
                                                        watchIsPG
                                                            ? props.totalTagihan
                                                            : Number(
                                                                  props.uangDibayar,
                                                              )
                                                    }
                                                    kembalian={
                                                        watchIsPG
                                                            ? 0
                                                            : props.kembalian
                                                    }
                                                    isPro={Number(1)}
                                                    namaMetode={
                                                        watchSelectedMetode
                                                            ? watchSelectedMetode.namaMetode
                                                            : "Tunai"
                                                    }
                                                    // html={
                                                    //     findCustomStruk &&
                                                    //     findCustomStruk.html !==
                                                    //         null
                                                    //         ? findCustomStruk?.html
                                                    //         : undefined
                                                    // }
                                                    keterangan={
                                                        props.keteranganBeli
                                                    }
                                                    noMetode={
                                                        watchSelectedMetode?.noTujuan ??
                                                        null
                                                    }
                                                    fee={
                                                        watchMetodeBayar?.totalFee
                                                            ? Number(
                                                                  watchMetodeBayar?.totalFee,
                                                              )
                                                            : null
                                                    }
                                                />
                                            ) : (
                                                <PrintStrukA4
                                                    warehouseData={
                                                        warehouseData
                                                    }
                                                    tanggalTransaksi={now}
                                                    transaksiKe={String(
                                                        transaksiKe,
                                                    )}
                                                    kasir={props.kasir}
                                                    sales={
                                                        props.sales?.nama ===
                                                        undefined
                                                            ? null
                                                            : props.sales.nama
                                                    }
                                                    total={props.totalTagihan}
                                                    cart={cart}
                                                    category={categoryData}
                                                    groupByKategori={
                                                        groupByKategori
                                                    }
                                                    diskon={props.diskon}
                                                    pajak={props.pajak}
                                                    // pajakPersen={
                                                    //     warehouseData?.pajak
                                                    // }
                                                    tunai={
                                                        watchIsPG
                                                            ? props.totalTagihan
                                                            : Number(
                                                                  props.uangDibayar,
                                                              )
                                                    }
                                                    kembalian={
                                                        watchIsPG
                                                            ? 0
                                                            : props.kembalian
                                                    }
                                                    namaMetode={
                                                        watchSelectedMetode &&
                                                        toggleModePembayaran ===
                                                            ModePembayaran.TRANSFER
                                                            ? watchSelectedMetode.namaMetode
                                                            : "Tunai"
                                                    }
                                                    // html={
                                                    //     findCustomStruk &&
                                                    //     findCustomStruk.html !==
                                                    //         null
                                                    //         ? findCustomStruk?.html
                                                    //         : undefined
                                                    // }
                                                    keterangan={
                                                        props.keteranganBeli
                                                    }
                                                    namaPemegang={
                                                        watchSelectedMetode?.namaPemegang ??
                                                        null
                                                    }
                                                    nomorTujuan={
                                                        watchSelectedMetode?.noTujuan ??
                                                        null
                                                    }
                                                    qr={
                                                        watchSelectedMetode?.gambar
                                                    }
                                                    fee={
                                                        watchMetodeBayar?.totalFee
                                                            ? Number(
                                                                  watchMetodeBayar?.totalFee,
                                                              )
                                                            : null
                                                    }
                                                />
                                            )
                                        }
                                    >
                                        {({ blob, url, loading, error }) => {
                                            return (
                                                <LoadingButton
                                                    loading={
                                                        loading ||
                                                        isButtonLoading
                                                    }
                                                    loadingPosition="center"
                                                    variant="contained"
                                                    fullWidth
                                                    size="large"
                                                    // href={
                                                    //     url ??
                                                    //     ""
                                                    // }
                                                    // target="_blank"
                                                    // rel="noreferrer"
                                                    onClick={(e) => {
                                                        if (blob) {
                                                            const blobFile =
                                                                new File(
                                                                    [blob],
                                                                    `Invoice_${warehouseData?.nama}_${now}.pdf`,
                                                                    {
                                                                        type: "application/pdf",
                                                                    },
                                                                );
                                                            const invoiceUrl =
                                                                window.URL.createObjectURL(
                                                                    blobFile,
                                                                );
                                                            console.log(
                                                                invoiceUrl,
                                                            );
                                                            window.open(
                                                                invoiceUrl,
                                                            );
                                                            onSubmit(e);
                                                        }
                                                    }}
                                                >
                                                    Bayar
                                                </LoadingButton>
                                            );
                                        }}
                                    </BlobProvider>
                                ) : (
                                    <LoadingButton
                                        loading={isButtonLoading}
                                        loadingPosition="center"
                                        variant="contained"
                                        fullWidth
                                        size="large"
                                        onClick={onSubmit}
                                    >
                                        Bayar
                                    </LoadingButton>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            {warehouseData && (
                <ModalAlertPro
                    isOpenModalAlertPro={isOpenModalAlertPro}
                    closeModalAlertPro={() => setIsOpenModalAlertPro(false)}
                    dataWarehouse={{
                        id: Number(warehouseData?.id),
                        nama: warehouseData?.nama,
                    }}
                />
            )}
        </Box>
    );
};

export default ModalKonfirmasiBayar;
